export const contentData = {
  spanish:{
    nodata:'Sin Registro',
    error:'Sin registro',
    subtitle:'Detalles',
    nospecialities:'No existen especialidades registradas',
    title:{
      sectionB:'Doctor',
      sectionC:'Detalles',
    },
    sectionA:{
      name:{
        label:'Nombre'
      },
      crm_id:{
        label:'CRM ID'
      },
      uci:{
        label:'UCI'
      },
    },
  },
  
}